// Constraints for tooltip size, should be in pixels
export const AUTOCOMPLETE_TOOLTIP_MAX_HEIGHT = 300;
export const AUTOCOMPLETE_TOOLTIP_WIDTH = 250;

export const HINTER_OPTIONS: CodeMirror.ShowHintOptions = {
  completeSingle: false,
};
